import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BookingModalComponent } from './layouts/booking-modal/booking-modal.component';
import { SOCIAL_LINKS } from './core/config/company-content.config';
import { AnalyticsService } from './core/services/analytics.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BookingModalComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'pixshiv';
  
  whatsappLink = SOCIAL_LINKS.whatsapp;
  showBackToTop = false;

  constructor(private analytics: AnalyticsService) {}

  // Note: All SEO (meta tags, schemas) is now handled by universalMetaResolver
  // Resolver runs BEFORE components load, ensuring SSR-friendly SEO for Google indexing

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Show button when user scrolls down 300px
    this.showBackToTop = window.pageYOffset > 300;
  }

  // Delegated click tracking: every tel:/WhatsApp link site-wide funnels through
  // here rather than needing a handler wired into each individual template.
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const anchor = (event.target as HTMLElement)?.closest?.('a') as HTMLAnchorElement | null;
    if (!anchor) {
      return;
    }

    const href = anchor.getAttribute('href') || '';
    if (href.startsWith('tel:')) {
      this.analytics.trackLead('phone_click', { phone_number: href.replace('tel:', '') });
    } else if (href.includes('wa.me') || href.includes('whatsapp')) {
      this.analytics.trackLead('whatsapp_click');
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
